/**
 * Detects user groups and sets global classes
 * on the <html> element similar to Modernizr
 *
 * This manages the HTML state **ONLY**, cookie handling
 * is done in wcs.context
 **/
define([
	'jquery',
	'wcs.context',
	'pubsub'
], function($, ctx) {
	var user = function() {
		var self = this;
		var $html = $('html'),
			classPrefix = 'vfdp-user-',
			userGroups = [
				{
					'name': 'registered',
					'contextKey': 'R',
				},{
					'name': 'guest',
					'contextKey': 'G'
				}
			];
		/**
		 * Formats the group name as an HTML class
		 * @private
		 * @param group name
		 **/
		var className = function(group) {
			return classPrefix+group;
		};

		/**
		 * Detect the current user group and set classes acordingly
		 **/
		this.identifyUserGroup = function() {
			var userType = ctx.getUserType(),
				userGroup = userGroups.filter(function(el) {
					return el.contextKey === userType;
				});

			if(userGroup.length > 0) {
				self.setGroup(userGroup[0].name);
				return userGroup[0].name;
			}

			self.setGroup('guest');
			return 'guest';
		};

		/**
		 * Clears all existing group classes from the HTML element
		 **/
		this.clearGroupClasses = function() {
			var classes = userGroups.map(function(el) {
				return className(el.name);
			});
			//remove class for loyalty
			classes.push(className("loyalty"));
			$html.removeClass(classes.join(' '));
		};

		/**
		 * Sets the current group class replacing
		 * any existing group classes
		 **/
		this.setGroup = function(group) {
			var matchedGroups = userGroups.filter(function(el) {
				return (el.name === group);
			});

			var loyaltyCookie = ctx.getLoyaltyProgramStatusCookie();

			if(matchedGroups.length > 0) {
				self.clearGroupClasses();
				$html.addClass(className(group));
				//make check and add class for loyalty
				if(loyaltyCookie != null && loyaltyCookie === "full") {
					$html.addClass(className("loyalty"));
				}
				return true;
			}

			throw new Error('User group '+group+' does not exist.');
		};

		// Adds a listener for user state changes
		// Updates the `vfdp-user-*` classes on the <html>
		// if the user state changes and the page doesn't reload
		$.pubsub('subscribe', 'vfdp.user.status', function() {
			self.identifyUserGroup();
		});

		// Self initialize
		this.identifyUserGroup();

		// Expose public methods for other modules to leverage
		return this;
	};
	return new user();
});
